module.exports = __webpack_public_path__ + "img/19.174c7e87.svg";